<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="02" :question="question"></QuestionTitle>
        <div class="container-70">
            <DoubleButtonChoice :button1="button1" :button2="button2" v-model="result" class="mt-100px" @update:modelValue="saveAndContinue('evenementDistanceChoice', JSON.stringify(result.label), result.link)" ></DoubleButtonChoice>
            <AccordeonBox :headerText="headerText" :bodyText="bodyText" class="mt-65px"></AccordeonBox>
            <AvancementLine percent="37.5%" class="mt-50px"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
            <h3 class="modal-title">GES émis par les transports de votre public</h3>
            <p class="modal-text">Au Québec, c'est le secteur des transports qui émet le plus de GES et contribue le plus au changement climatique. Cette section permet d'estimer les GES émis par les transports effectués dans le cadre de votre évènement. Les données seront recueillies en trois catégories : les personnes participantes à l'évènement (votre public), les organisateurs, partenaires, fournisseurs, bénévoles, et enfin les artistes, conférenciers ou invités.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import DoubleButtonChoice from '@/components/DoubleButtonChoice.vue'
import AccordeonBox from '@/components/AccordeonBox.vue'
import AvancementLine from '@/components/AvancementLine.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Par quel moyen souhaitez-vous calculer les émissions de GES émis par votre flotte de véhicules?',
            modalActive:false,
            button1:{
                link:'./question-3-option-a',
                label:'Selon les distances parcourues (km)'
            },
            button2:{
                link:'./question-3-option-b',
                label:'Selon les dépenses ($) en carburant'
            },
            headerText:'Besoin d’aide pour faire votre choix?',
            bodyText:'Si vous avez de la machinerie (tracteur, dameuse, pelle mécanique, etc.) en plus des véhicules légers et lourds, choisissez l\'option des dépenses en carburant.'
        }
    },
    components: {
        QuestionTitle,
        AccordeonBox,
        AvancementLine,
        DoubleButtonChoice
    },
    mixins:[utils]
}
</script>